<div id="iframe-portalV1">
  <div class="container-fluid">
    <nav class="navbar navbar-expand navbar-light bg-light mb-3" id="breadcrumb-sf-1">
      <nav aria-label="breadcrumb" class="navbar-nav mr-auto">
        <ol class="breadcrumb ol-sf-1">
          <li class="breadcrumb-item">
            <a *roles="['ROLE_MCKAY']" routerLink="/mckay/{{getUserCurrent().company.uniqid}}">Home</a>
            <a *roles="['ROLE_CLIENT']" routerLink="/client/{{getUserCurrent().company.uniqid}}">Home</a>
          </li>
          <li class="breadcrumb-item">
            <a routerLink="/document">Downloads</a>
          </li>
          <li aria-current="page" class="breadcrumb-item">
            <a routerLink="/document/{{document?.uniqid}}/show">{{ document?.title }}</a>
          </li>
          <li aria-current="page" class="breadcrumb-item active">
            {{ document?.title }} announcement
          </li>
        </ol>
      </nav>
    </nav>
    <div *ngIf="error" class="alert alert-danger alert-dismissible fade show">
      {{ errorMessage }}
      <button (click)="error = false" aria-label="Close" class="close" type="button">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <h3><b>{{ pageTitle }}</b></h3>
    <form (keydown.enter)="$event.preventDefault()">
      <div class="row">
        <div class="col-6 col-md-12 col-lg-6">
          <div class="form-group col-12">
            <label class="control-label col-5">Cc: Mckay Brothers users</label>
            <div class="col-7 no-padding">
              <div class="custom-control custom-checkbox">
                <p-checkbox #ccMckay="ngModel" [(ngModel)]="documentNotification.ccMckay" [binary]="true"
                            label="" name="ccMckay"></p-checkbox>
              </div>
            </div>
          </div>
          <div class="form-group col-12">
            <label class="control-label col-4">Banner and footer</label>
            <div class="col-8 no-padding">
              <div class="custom-control custom-checkbox">
                <div *ngFor="let lab of bannersOptions" class="custom-control custom-checkbox margin-bottom-10">
                  <p-radioButton #banner="ngModel" [(ngModel)]="documentNotification.banner" label={{lab.label}}
                                 name="label{{lab.value}}" value={{lab.value}}></p-radioButton>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="displayOneSectionUsers" class="form-group col-12">
            <label class="control-label col-6">Users</label>
            <div class="col-12 no-padding">
              <span *ngIf="noSelectedUser"
                    class="error-text"> Please select at least one user to send the notification</span>
              <div class="custom-control custom-checkbox">
                <p-group-multiselect (selectedOptionsEvent)="fillSelectedUsersIds($event)" [options]="usersOptions" [selectedItemsLabel]="'Select users'"
                                     appendTo="body"></p-group-multiselect>
              </div>
            </div>
          </div>
          <div *ngIf="displayTwoSectionUsers" class="form-group col-12">
            <label class="control-label col-6">Send To: users watching this document</label>
            <div class="col-12 no-padding">
              <div class="custom-control custom-checkbox">
                <p-group-multiselect (selectedOptionsEvent)="fillSelectedUsersDownloadedDocIds($event)" [options]="watchingUsersOptions"
                                     [selectedCompanies]="selectedCompanies" [selectedItemsLabel]="'Select users'"
                                     appendTo="body"></p-group-multiselect>
              </div>
            </div>
          </div>
          <div *ngIf="displayTwoSectionUsers" class="form-group col-12">
            <label class="control-label col-6">Send To: users not watching this document</label>
            <div class="col-12 no-padding">
              <div class="custom-control custom-checkbox">
                <p-group-multiselect (selectedOptionsEvent)="fillSelectedNewUsersIds($event)" [options]="newUsersOptions" [selectedItemsLabel]="'Select users'"
                                     appendTo="body"></p-group-multiselect>
              </div>
            </div>
          </div>
        </div>
        <div class="col-6 col-md-12 col-lg-6">
          <div *ngIf="documentNotification.banner === '1' || documentNotification.banner === '3'"
               class="form-group col-12" style="text-align: center;">
            <img alt="" src="../../../assets/images/logo-mckay.png">
          </div>
          <div *ngIf="documentNotification.banner === '2'" class="form-group col-12" style="text-align: center;">
            <img alt="" src="../../../assets/images/logo-quincy.png">
          </div>
          <div class="form-group col-12">
            <label>Subject</label>
            <div class="pl-2">
              <input #name="ngModel" [(ngModel)]="documentNotification.subject" class="form-control" maxlength="255" name="subject"
                     pInputText placeholder="Subject" type="text">
            </div>
          </div>
          <div class="form-group  col-12">
            <label>Message</label>
            <div class="pl-2">
              <p-editor [(ngModel)]="documentNotification.message" name="message" placeholder="Body"></p-editor>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 d-flex justify-content-end">
        <div class="margin-left-5" style="margin: 2px">
          <button (click)="redirectionToHomePage()" class="btn btn-outline-secondary" id="cancel_button"><i
            aria-hidden="true" class="fa fa-refresh pr-2" type="button"></i>Cancel
          </button>
        </div>
        <div class="margin-left-5" style="margin: 2px">
          <button [disabled]="documentNotification.users.length===0 && !this.documentNotification.ccMckay"
                  class="btn btn-outline-primary" id="send_button" (click)="sendNotification()">
            <i aria-hidden="true" class="fa fa-send-o pr-2"></i>Send notification
          </button>
        </div>
        <div class="margin-left-5" style="margin: 2px">
          <button (click)="previewEmail()" class="btn btn-outline-primary" id="preview_button" type="button">
            <i aria-hidden="true" class="fa fa-send-o pr-2"></i>Preview Email
          </button>
        </div>
      </div>
    </form>
    <p-dialog [(visible)]="display" dismissableMask="true" header="{{title}}" modal="true">
      <div class="form-group" style="text-align: center;">
        <img alt="" src="{{srcImg}}">
      </div>
      <div [innerHTML]="messagePreview" style="font-size: 12px"></div>
      <br>
      <br>
      <p [innerHTML]="getFooter()" style="color: grey; font-size: 12px">
      </p>
    </p-dialog>

  </div>
</div>
